module.exports = __webpack_public_path__ + "static/media/105.cf91bcb5.jpg";